import { Component, inject } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Guid } from 'guid-typescript';
import { ToastService } from 'src/app/services/toast.service';
import { WorkloadsService } from 'src/app/services/workloads.service';
import { FranchiseModalComponent } from '../franchise-modal/franchise-modal.component';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-point-sale',
    imports: [ReactiveFormsModule, MatInputModule, MatButtonModule, MatIconModule],
    templateUrl: './point-sale.component.html',
    styleUrls: ['./point-sale.component.scss']
})
export class PointSaleComponent {
  toastr = inject(ToastService);
  franchiseSvc = inject(WorkloadsService);
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<FranchiseModalComponent>>(MatDialogRef);

  pointSaleForm = this.getPointSaleForm();

  ngOnInit() {
    if (this.data.franchiseData) {
      this.pointSaleForm.controls.companyName.patchValue(
        this.data.franchiseData.companyName
      );
    } else {
      if (this.data.selectedPOS && this.data.companyName) {
        this.pointSaleForm.controls.companyName.patchValue(this.data.companyName);
        this.pointSaleForm.controls.description.patchValue(
          this.data.selectedPOS.description
        );
      }
    }
  }

  onSubmit() {
    if (this.pointSaleForm.valid) {
      if (this.data.franchiseData) {
        this.franchiseSvc
          .postFranchisePointSale(
            this.data.franchiseData.id,
            this.pointSaleForm.controls.description.value
          )
          .subscribe({
            next: (data) => {
              this.toastr.success(
                'Punto de venta asociado',
                'Nuevo Punto de venta asociado a la franquicia.'
              );
              this.cleanForm();
            },
            error: (err) => {
              this.toastr.error(
                'Error',
                'Error al registrar el Punto de venta.'
              );
            },
          });
      } else {
        if (this.data.selectedPOS && this.data.franchiseId) {
          this.franchiseSvc
            .updatePointSale(
              this.data.selectedPOS.id.toString(),
              this.data.franchiseId,
              this.pointSaleForm.controls.description.value
            )
            .subscribe({
              next: (data) => {
                this.toastr.success(
                  'Punto de venta editado',
                  'Punto de venta editado correctamente.'
                );
                this.cleanForm();
              },
              error: (err) => {
                this.toastr.error(
                  'Error',
                  'Error al editar el Punto de venta.'
                );
              },
            });
        }
      }
    } else {
      this.pointSaleForm.markAllAsTouched();
    }
  }

  getPointSaleForm(): UntypedFormGroup {
    let formGroup = new UntypedFormGroup({
      id: new UntypedFormControl(Guid.EMPTY.toString()),
      description: new UntypedFormControl('', Validators.required),
      companyName: new UntypedFormControl('', Validators.required),
    });
    formGroup.controls.companyName.disable();

    return formGroup;
  }

  cleanForm() {
    this.pointSaleForm.reset();
    this.closeClick();
  }

  closeClick() {
    this.dialogRef.close();
  }
}
